"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSpeedEvent = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../BaseAvroRecord");
class PageSpeedEvent extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.navigationTimingJson = "";
        this.geo = null;
    }
    schema() {
        return PageSpeedEvent.schema;
    }
    subject() {
        return PageSpeedEvent.subject;
    }
}
exports.PageSpeedEvent = PageSpeedEvent;
PageSpeedEvent.subject = "page-speed-event";
PageSpeedEvent.schema = {
    "type": "record",
    "name": "PageSpeedEvent",
    "namespace": "storyblocks.navigation",
    "doc": "* @see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming\n\t* @see https://community.akamai.com/customers/s/article/Using-Navigation-Timing-APIs-to-understand-your-webpage",
    "fields": [
        {
            "name": "meta",
            "type": {
                "type": "record",
                "name": "Meta",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "uuid",
                        "type": "string"
                    },
                    {
                        "name": "emitted",
                        "type": {
                            "type": "long",
                            "logicalType": "timestamp-millis"
                        }
                    },
                    {
                        "name": "origin",
                        "type": {
                            "type": "enum",
                            "name": "Origin",
                            "symbols": [
                                "VIDEOBLOCKS",
                                "AUDIOBLOCKS",
                                "GRAPHICSTOCK",
                                "STORYBLOCKS",
                                "STORYBLOCKS_NEXTJS",
                                "CONTRIBUTOR_PORTAL",
                                "TEMPLATE_EDITOR",
                                "ACCOUNT_SERVICE",
                                "BILLING_SERVICE",
                                "CONTENT_SERVICE",
                                "PAYOUT_SERVICE",
                                "TRANSLATION_SERVICE",
                                "CONTENT_RATING_APP",
                                "FEATURE_FLAG_SERVICE",
                                "PREMIERE_PRO_PLUGIN",
                                "AFTER_EFFECTS_PLUGIN",
                                "EXAMPLE_SERVICE",
                                "SEARCH_SERVICE",
                                "CONTENT_JOB",
                                "DATA_JOB",
                                "MISC",
                                "STORYBOARD",
                                "USER_SERVICE",
                                "SUBSCRIPTION_SERVICE",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "trace",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "TraceContext",
                                "fields": [
                                    {
                                        "name": "traceId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "pageTraceId",
                                        "type": "string",
                                        "default": ""
                                    },
                                    {
                                        "name": "spanId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "parentId",
                                        "type": "string",
                                        "default": ""
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "user",
            "type": {
                "type": "record",
                "name": "User",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "visitorCookieId",
                        "type": [
                            "null",
                            "string"
                        ]
                    },
                    {
                        "name": "userId",
                        "type": [
                            "null",
                            "int"
                        ]
                    },
                    {
                        "name": "subscriptionId",
                        "type": [
                            "null",
                            "int"
                        ]
                    },
                    {
                        "name": "recurlySubscriptionId",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "recurlySubscriptionUuid",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "organizationId",
                        "type": [
                            "null",
                            "int"
                        ],
                        "default": null
                    },
                    {
                        "name": "bot",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "Bot",
                                "fields": [
                                    {
                                        "name": "isBot",
                                        "type": "boolean"
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "device",
            "type": {
                "type": "record",
                "name": "Device",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "browser",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "Browser",
                                "namespace": "storyblocks.common.frontend",
                                "fields": [
                                    {
                                        "name": "userAgent",
                                        "type": "string"
                                    },
                                    {
                                        "name": "language",
                                        "type": "string"
                                    },
                                    {
                                        "name": "platform",
                                        "type": "string"
                                    },
                                    {
                                        "name": "name",
                                        "type": [
                                            "null",
                                            "string"
                                        ],
                                        "default": null
                                    }
                                ]
                            }
                        ],
                        "default": null
                    },
                    {
                        "name": "tab",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "Tab",
                                "namespace": "storyblocks.common.frontend",
                                "fields": [
                                    {
                                        "name": "isNewTab",
                                        "type": "boolean"
                                    },
                                    {
                                        "name": "tabCount",
                                        "type": "int"
                                    },
                                    {
                                        "name": "tabId",
                                        "type": "string"
                                    }
                                ]
                            }
                        ],
                        "default": null
                    },
                    {
                        "name": "navigation",
                        "type": {
                            "type": "record",
                            "name": "Navigation",
                            "namespace": "storyblocks.common.frontend",
                            "fields": [
                                {
                                    "name": "referrerUrl",
                                    "type": "string"
                                },
                                {
                                    "name": "navigationType",
                                    "type": [
                                        "null",
                                        {
                                            "type": "enum",
                                            "name": "NavigationType",
                                            "namespace": "storyblocks.common.enums",
                                            "symbols": [
                                                "TYPE_NAVIGATE",
                                                "TYPE_RELOAD",
                                                "TYPE_BACK_FORWARD",
                                                "TYPE_RESERVED",
                                                "OUTDATED_SCHEMA"
                                            ],
                                            "default": "OUTDATED_SCHEMA"
                                        }
                                    ],
                                    "default": null
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "name": "urls",
            "type": {
                "type": "record",
                "name": "Urls",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "currentUrl",
                        "type": "string"
                    },
                    {
                        "name": "referrerUrl",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "dnsLookupMs",
            "type": "int",
            "doc": "domainLookupEnd - domainLookupStart"
        },
        {
            "name": "domLoadedMs",
            "type": "int",
            "doc": "domComplete - requestStart"
        },
        {
            "name": "loadCompleteMs",
            "type": "int",
            "doc": "loadEventEnd - requestStart"
        },
        {
            "name": "tcpConnectMs",
            "type": "int",
            "doc": "connectEnd - connectStart"
        },
        {
            "name": "timeToFirstByteMs",
            "type": "int",
            "doc": "responseStart - requestStart"
        },
        {
            "name": "timeToInteractiveMs",
            "type": "int",
            "doc": "domInteractive - requestStart"
        },
        {
            "name": "timeToFirstPaintMs",
            "type": "int",
            "doc": "domContentLoadedEventEnd - requestStart"
        },
        {
            "name": "redirectMs",
            "type": "int",
            "doc": "redirectEnd - redirectStart"
        },
        {
            "name": "navigationTimingJson",
            "type": "string",
            "default": ""
        },
        {
            "name": "geo",
            "type": [
                "null",
                {
                    "type": "record",
                    "name": "Geo",
                    "namespace": "storyblocks.common",
                    "fields": [
                        {
                            "name": "countryCode",
                            "type": "string"
                        },
                        {
                            "name": "country",
                            "type": "string"
                        },
                        {
                            "name": "continent",
                            "type": "string"
                        }
                    ]
                }
            ],
            "default": null
        }
    ]
};
//# sourceMappingURL=PageSpeedEvent.js.map